export { }
declare global {
    export interface Number {
        toLocalePrice(locale?: string): string;
        customRound(decimalPlaces: number): number;
        roundAwayFromZero(decimals: number): number;
    }
}

Number.prototype.toLocalePrice = function (locale?: string): string {
    const formattedNumber = this.toLocaleString(locale ?? 'pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    return formattedNumber;
};

Number.prototype.customRound = function (decimalPlaces: number): number {
    let factor = Math.pow(10, decimalPlaces);
    return (Math.round(Number(this) * factor) / factor);
}

Number.prototype.roundAwayFromZero = function (decimals: number): number {
    const factor = 10 ** decimals;
    const absValue = Math.abs(Number(this));
    // “fudge” para compensar imprecisão: EPSILON * magnitude aproximada
    const fudge = Number.EPSILON * absValue * factor;
    const roundedAbs = Math.floor(absValue * factor + 0.5 + fudge) / factor;
    return Math.sign(Number(this)) * roundedAbs;
}